import moment from 'moment-timezone';
import { getShopLink, parseApiError, parsePrice } from '../../../assets/utils/utils';

export const ADVERTISING_CAMPAIGNS_LIMIT = 20;

export const ADVERTISING_STATUS_OPTIONS = [
    { value: '', title: 'Все статусы' },
    { value: 'created', title: 'Создана' },
    { value: 'waiting_payment', title: 'Ожидает оплаты' },
    { value: 'paid', title: 'Оплачено' },
    { value: 'passed_review', title: 'Прошло проверку' },
    { value: 'launched', title: 'Реклама запущена' },
    { value: 'in_progress', title: 'Идет продвижение' },
    { value: 'report_required', title: 'Требуется отчет' },
    { value: 'report_provided', title: 'Отчет предоставлен' },
    { value: 'completed', title: 'Завершено' },
    { value: 'rejected', title: 'Отклонено' },
    { value: 'canceled', title: 'Отменено' },
];

export const ADVERTISER_TYPE_OPTIONS = [
    { value: 'ip', title: 'ИП' },
    { value: 'company', title: 'Компания' },
    { value: 'individual', title: 'Физическое лицо' },
];

export const ADVERTISING_FORM_LABELS = {
    advertiser_type: 'Тип рекламодателя',
    advertiser_name: 'Рекламодатель',
    inn: 'ИНН',
    ogrn_or_ogrnip: 'ОГРН / ОГРНИП',
    contact_email: 'Email',
    contact_phone: 'Телефон',
    store_url: 'Ссылка на магазин',
    product_category: 'Категория товаров',
    geo: 'География продвижения',
    comment: 'Комментарий',
};

export function getStatusFallbackTitle(status) {
    return ADVERTISING_STATUS_OPTIONS.find((item) => item.value === status)?.title || status || '-';
}

export function getCampaignStatusTitle(campaign) {
    return campaign?.status_title || getStatusFallbackTitle(campaign?.status);
}

export function getAdvertiserTypeTitle(value) {
    return ADVERTISER_TYPE_OPTIONS.find((item) => item.value === value)?.title || value || '-';
}

export function formatAdvertisingDate(value) {
    if (!value) return '-';

    const stringValue = String(value);
    const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(stringValue);
    const parsed = moment(hasTimezone ? stringValue : `${stringValue}+00:00`);

    return parsed.isValid() ? parsed.format('DD.MM.YYYY HH:mm') : '-';
}

export function formatAdvertisingDateOnly(value) {
    if (!value) return '-';

    const stringValue = String(value);
    const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(stringValue);
    const parsed = moment(hasTimezone ? stringValue : `${stringValue}+00:00`);

    return parsed.isValid() ? parsed.format('DD.MM.YYYY') : '-';
}

export function formatAdvertisingMoney(amount, currency) {
    if (!amount) return '-';
    return parsePrice(amount, currency || 'RUB');
}

export function getShopId(shop) {
    return shop?._id || shop?.id || '';
}

export function getShopName(shop) {
    return shop?.info?.name || shop?.name || shop?.title || 'Магазин';
}

export function getShopDefaultUrl(shop) {
    if (!shop) return '';
    if (shop.domain) return getShopLink({ domain_info: shop.domain });
    if (shop.domain_info) return getShopLink({ domain_info: shop.domain_info });
    return shop.url || '';
}

export async function loadAllAvailableShops(api, limit = 25) {
    let last_id = null;
    let is_more = true;
    const shops = [];
    const seen = new Set();

    while (is_more) {
        const response = await api.getAvailibleShops({ limit, last_id });
        const nextShops = response?.data || [];

        nextShops.forEach((shop) => {
            const shopId = getShopId(shop);
            if (!shopId || seen.has(shopId)) return;
            seen.add(shopId);
            shops.push(shop);
        });

        is_more = Boolean(response?.is_more) && nextShops.length > 0;
        last_id = nextShops[nextShops.length - 1]?.iam_id || nextShops[nextShops.length - 1]?._id || null;
        if (!last_id) is_more = false;
    }

    return shops;
}

export function parseAdvertisingApiError(error) {
    if (!error || !error.statusCode) return parseApiError(error);

    switch (error.statusCode) {
        case 401:
            return 'Необходима авторизация. Войдите в аккаунт и повторите действие.';
        case 403:
            return 'Нет доступа к выбранному магазину или разделу рекламы.';
        case 404:
            return 'Тариф или заявка не найдены. Обновите страницу и попробуйте снова.';
        case 422:
            return 'Проверьте поля формы: часть данных заполнена неверно.';
        case 500:
            return 'Не удалось создать платеж YooKassa. Попробуйте позже или обратитесь в поддержку.';
        default:
            return parseApiError(error);
    }
}

export function getPaymentUrl(campaign) {
    return campaign?.confirmation_url || campaign?.invoice_url || '';
}
